/* eslint-disable max-len */
import {
  MdAdsClick,
  MdAssignment,
  MdAutoFixHigh,
  MdCalculate,
  MdEmojiEvents,
  MdFileDownload,
  MdHandshake,
  MdHub,
  MdLibraryAddCheck,
  MdLocalOffer,
  MdOfflinePin,
  MdSave,
  MdStore,
  MdTimeline,
  MdWatchLater,
} from 'react-icons/md';
import { IoMdNotifications } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { Dropdown, Icon, Nav, Tooltip, Whisper } from 'rsuite';
import IndustriaIcon from '../assets/elasticidade-cruzada/industria.svg';
import AiSidebar from '../assets/icons/ai-sidebar.svg';
import { usePsychologicalPriceNavigation } from '../pages/IPA/PrecoPsicologico/hooks/usePsychologicalPriceNavigation';
import {
  canAccessIpaCampaigns,
  canAccessIpaNegotiation,
  canAccessIpaPriceArchitecture,
  canAccessIpaPriceOptimization,
  IPA_PRICE_ARCHITECTURE_PATH,
  isIpaBasicPackage,
} from '../utils/ipaAccess';

/** Logins que veem o menu Indústria mesmo sem `codigoCliente` na lista legada (acesso interno / demo). */
const IDS_ALLOWED_INDUSTRY_MENU_BY_LOGIN = ['paulo@infoprice.co'];

// Custom SVG Icons
const RevisaoListaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.74167 12.5C10.0417 11.875 10.4417 11.3083 10.9333 10.8333H5.83333V9.16665H15C15.8917 9.16665 16.7417 9.37498 17.5 9.74164V4.16665C17.5 3.24998 16.75 2.49998 15.8333 2.49998H12.35C12 1.53331 11.0833 0.833313 10 0.833313C8.91667 0.833313 8 1.53331 7.65 2.49998H4.16667C3.25 2.49998 2.5 3.24998 2.5 4.16665V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H9.74167C9.375 16.7416 9.16667 15.8916 9.16667 15C9.16667 14.7166 9.19167 14.4416 9.23333 14.1666H5.83333V12.5H9.74167ZM10 2.29165C10.3417 2.29165 10.625 2.57498 10.625 2.91665C10.625 3.25831 10.3417 3.54165 10 3.54165C9.65833 3.54165 9.375 3.25831 9.375 2.91665C9.375 2.57498 9.65833 2.29165 10 2.29165ZM5.83333 5.83331H14.1667V7.49998H5.83333V5.83331Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 10.8333C12.7 10.8333 10.8333 12.7 10.8333 15C10.8333 17.3 12.7 19.1666 15 19.1666C17.3 19.1666 19.1667 17.3 19.1667 15C19.1667 12.7 17.3 10.8333 15 10.8333ZM12.5 15.95V16.9791H13.5292L16.4 14.1166C16.4833 14.0333 16.4833 13.9041 16.4 13.8208L15.6625 13.0833C15.5792 13 15.45 13 15.3667 13.0833L12.5 15.95ZM14.375 16.9791H17.5V16.1458H15.2083L14.375 16.9791Z"
      fill="currentColor"
    />
  </svg>
);

const LojasBloqueadasIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4999 15.8333C12.4999 13.9916 13.9916 12.5 15.8333 12.5C17.6749 12.5 19.1666 13.9916 19.1666 15.8333C19.1666 17.675 17.6749 19.1666 15.8333 19.1666C13.9916 19.1666 12.4999 17.675 12.4999 15.8333ZM13.7499 15.8333C13.7499 14.6833 14.6833 13.75 15.8333 13.75C16.1833 13.75 16.4999 13.8416 16.7916 13.9916L13.9916 16.7916C13.8416 16.5 13.7499 16.1833 13.7499 15.8333ZM14.8749 17.675C15.1666 17.825 15.4833 17.9166 15.8333 17.9166C16.9832 17.9166 17.9166 16.9833 17.9166 15.8333C17.9166 15.4833 17.8249 15.1666 17.6749 14.875L14.8749 17.675Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1666 12.0131V11.6666H14.9999V9.99998L14.1666 5.83331H1.66659L0.833252 9.99998V11.6666H1.66659V16.6666H9.16658V11.6666H12.4999V13.3322C12.9296 12.7604 13.503 12.3028 14.1666 12.0131ZM3.33325 15H7.49992V11.6666H3.33325V15Z"
      fill="currentColor"
    />
    <path d="M14.1666 3.33331H1.66659V4.99998H14.1666V3.33331Z" fill="currentColor" />
  </svg>
);

const AnaliseCoberturaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M11.5181 14.9999C11.5181 16.183 10.5581 17.143 9.375 17.143C8.19187 17.143 7.23187 16.183 7.23187 14.9999C7.23187 14.1067 7.79 13.2924 8.66062 12.9799V5.71424H10.0894V12.9799C10.96 13.2924 11.5181 14.1074 11.5181 14.9999ZM12.9462 14.9999C12.9462 13.828 12.3881 12.8011 11.5175 12.143V3.57174C11.5175 2.38861 10.5575 1.42861 9.37437 1.42861C8.19125 1.42861 7.23125 2.38861 7.23125 3.57174V12.143C6.36063 12.8017 5.8025 13.828 5.8025 14.9999C5.8025 16.9755 7.39875 18.5711 9.37375 18.5711C11.3488 18.5711 12.945 16.9749 12.945 14.9999H12.9462ZM14.375 14.9999C14.375 17.7567 12.1319 19.9999 9.375 19.9999C6.61813 19.9999 4.375 17.7567 4.375 14.9999C4.375 13.638 4.92188 12.4105 5.80375 11.5067V3.57174C5.80375 1.59611 7.4 0.000488281 9.375 0.000488281C11.35 0.000488281 12.9462 1.59674 12.9462 3.57174V11.5067C13.8281 12.4105 14.375 13.6386 14.375 14.9999ZM15.8037 8.57111V9.99986H13.6606V8.57111H15.8037ZM15.8037 5.71424V7.14299H13.6606V5.71424H15.8037ZM15.8037 2.85674V4.28549H13.6606V2.85674H15.8037Z"
      fill="currentColor"
    />
  </svg>
);

const AderenciaPrecosIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10.6665 8C10.6665 9.46886 9.46828 10.6665 8 10.6665C6.53172 10.6665 5.33353 9.46828 5.33353 8C5.33353 6.53172 6.53172 5.33353 8 5.33353C9.46828 5.33353 10.6665 6.53172 10.6665 8ZM11.9994 8C11.9994 5.79145 10.208 4 7.99942 4C5.79087 4 3.99942 5.79145 3.99942 8C3.99942 10.2085 5.79087 12 7.99942 12C10.208 12 11.9994 10.2085 11.9994 8ZM13.3329 8C13.3329 10.9482 10.9476 13.3335 7.99942 13.3335C5.05119 13.3335 2.66589 10.9482 2.66589 8C2.66589 5.05177 5.05119 2.66647 7.99942 2.66647C10.9476 2.66647 13.3329 5.05177 13.3329 8ZM14.6665 8C14.6665 4.32259 11.6768 1.33294 7.99942 1.33294C4.32201 1.33294 1.33236 4.32259 1.33236 8C1.33236 11.6774 4.32201 14.6671 7.99942 14.6671C11.6768 14.6671 14.6665 11.6774 14.6665 8ZM16 8C16 12.4165 12.4165 16 8 16C3.58349 16 0 12.4165 0 8C0 3.58349 3.58349 0 8 0C12.4165 0 16 3.58349 16 8Z" // eslint-disable-next-line max-len
      fill="currentColor"
      transform="translate(2, 2)"
    />
  </svg>
);

const PanelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.5835 14.7346H3.75016L3.75016 3.33588L12.0835 3.29501V8.62797C12.5002 8.22087 13.3335 7.81378 13.7502 7.81378V3.29501C13.7502 2.3994 13.0002 1.66663 12.0835 1.66663L3.75016 1.70749C2.8335 1.70749 2.0835 2.44027 2.0835 3.33588L2.0835 14.7346C2.0835 15.6302 2.8335 16.3629 3.75016 16.3629H7.91683L9.5835 14.7346ZM13.0085 15.793C13.5918 16.1513 14.2668 16.3629 15.0002 16.3629C17.0752 16.3629 18.7502 14.7264 18.7502 12.6991C18.7502 10.6717 17.0752 9.03522 15.0002 9.03522C12.9252 9.03522 11.2502 10.6717 11.2502 12.6909C11.2502 13.4074 11.4668 14.0751 11.8335 14.6369L9.2335 17.1771L10.4168 18.3333L13.0085 15.793ZM12.9168 12.6991C12.9168 11.5755 13.8502 10.6636 15.0002 10.6636C16.1502 10.6636 17.0835 11.5755 17.0835 12.6991C17.0835 13.8227 16.1502 14.7346 15.0002 14.7346C13.8502 14.7346 12.9168 13.8227 12.9168 12.6991Z"
      fill="currentColor"
    />
    <path
      d="M10.4168 11.7492V9.03522C10.4168 8.66205 10.0954 8.35673 9.70254 8.35673H6.8454V6.99974H10.4168V5.64276H8.63112V4.96426H7.20254V5.64276H6.13112C5.73826 5.64276 5.41683 5.94808 5.41683 6.32125V9.03522C5.41683 9.40839 5.73826 9.71372 6.13112 9.71372H8.98826V11.0707H5.41683V12.4277H7.20254V13.1062H8.63112V12.4277H9.70254C10.0954 12.4277 10.4168 12.1224 10.4168 11.7492Z"
      fill="currentColor"
    />
  </svg>
);

export const IpaMenu = ({ activeKeyMenu, user }) => {
  const navigateToPsychologicalPrice = usePsychologicalPriceNavigation();
  const isBasicIpa = isIpaBasicPackage(user);
  const allowerUsersToAcessIpaNegotiation = canAccessIpaNegotiation(user);

  const allowerUsersToAcessIpaPricesOptimization = canAccessIpaPriceOptimization(user);

  const allowedToAccessCampaign = canAccessIpaCampaigns(user);

  const allowedToAccessPriceArchitecture = canAccessIpaPriceArchitecture(user);

  return (
    <Nav className="sidebar-desktop" data-ipa-menu>
      {!isBasicIpa && (
        <>
          <Nav.Item
            componentClass={Link}
            to="/ipa/gerenciador-de-precos"
            eventKey="4"
            icon={
              <Icon asChild>
                <MdOfflinePin size={20} style={{ height: '20px', width: '20px' }} />
              </Icon>
            }
          >
            Gerenciador de preços
          </Nav.Item>
          <Whisper placement="topStart" speaker={<Tooltip>Estratégia</Tooltip>}>
            <Dropdown
              activeKey={activeKeyMenu}
              eventKey="1"
              title="Estratégia"
              placement="rightStart"
              icon={
                <Icon asChild>
                  <MdAutoFixHigh style={{ height: '20px', width: '20px' }} />
                </Icon>
              }
            >
              <Dropdown.Item eventKey="1-1" componentClass={Link} to="/ipa/regras-preco">
                Regras de preço
              </Dropdown.Item>
              <Dropdown.Item eventKey="1-2" componentClass={Link} to="/ipa/limites-preco">
                Limites de preço
              </Dropdown.Item>
              <Dropdown.Item eventKey="1-3" onSelect={navigateToPsychologicalPrice}>
                Preço psicológico
              </Dropdown.Item>
              <Dropdown.Item eventKey="1-4" componentClass={Link} to="/ipa/tabela-precos">
                Tabela de preços
              </Dropdown.Item>
              <Dropdown.Item eventKey="1-5" componentClass={Link} to="/ipa/estrategia/margem-objetiva">
                Margem Objetiva
              </Dropdown.Item>
              {allowedToAccessPriceArchitecture && (
                <Dropdown.Item eventKey="1-5b" componentClass={Link} to={IPA_PRICE_ARCHITECTURE_PATH}>
                  Arquitetura de preços
                </Dropdown.Item>
              )}
              <Dropdown.Item eventKey="1-6" componentClass={Link} to="/ipa/estrategia/preco-atacado">
                Preço Atacado
              </Dropdown.Item>
            </Dropdown>
          </Whisper>

          {allowedToAccessCampaign && (
            <Nav.Item
              componentClass={Link}
              to="/ipa/campanhas"
              eventKey="8"
              icon={
                <Icon asChild>
                  <MdLocalOffer style={{ height: '20px', width: '20px' }} />
                </Icon>
              }
            >
              Campanhas
            </Nav.Item>
          )}
        </>
      )}
      {allowerUsersToAcessIpaNegotiation && (
        <Whisper placement="topStart" speaker={<Tooltip>Negociação fornecedor</Tooltip>}>
          <Dropdown
            activeKey={activeKeyMenu}
            eventKey="3"
            title="Negociações fornecedor"
            placement="rightStart"
            icon={
              <Icon asChild>
                <MdHandshake style={{ height: '20px', width: '20px' }} />
              </Icon>
            }
          >
            <Dropdown.Item eventKey="3-1" componentClass={Link} to="/ipa/negociacoes/fornecedor">
              Negociação fornecedor
            </Dropdown.Item>
            <Dropdown.Item eventKey="3-2" componentClass={Link} to="/ipa/negociacoes/salvas">
              Negociações salvas
            </Dropdown.Item>
            {/*
              Negociação manual é o nome da casa para o simulador tributário, que
              é outro produto: este item abre a tela inicial dele, a que lista as
              análises do cliente. O endereço não tem identificador de análise de
              propósito, e a travessia que abre a sessão é a mesma dos dois casos.

              Ele entra DENTRO do bloco já guardado: não há condição nova de
              acesso, e o cliente sem o módulo continua sem ver nenhum dos três.
              A rota do simulador tem a mesma guarda, para o endereço digitado.
            */}
            <Dropdown.Item eventKey="3-3" componentClass={Link} to="/simulador">
              Negociação manual
            </Dropdown.Item>
          </Dropdown>
        </Whisper>
      )}
      {!isBasicIpa && (
        <>
          <Nav.Item
            componentClass={Link}
            to="/ipa/extracao-preco"
            eventKey="5"
            icon={
              <Icon asChild>
                <MdFileDownload style={{ height: '20px', width: '20px' }} />
              </Icon>
            }
          >
            Extração de preços
          </Nav.Item>

          <Whisper placement="topStart" speaker={<Tooltip>Precifique com IA</Tooltip>}>
            <Dropdown
              activeKey={activeKeyMenu}
              eventKey="7"
              title="Precifique com IA"
              placement="rightStart"
              icon={
                <Icon asChild>
                  <img src={AiSidebar} alt="IA" style={{ height: '20px', width: '20px' }} />
                </Icon>
              }
            >
              {allowerUsersToAcessIpaPricesOptimization && (
                <Dropdown.Item eventKey="7-1" componentClass={Link} to="/ipa/ia/otimizacao-de-precos/lista">
                  Otimização de preços
                </Dropdown.Item>
              )}

              <Dropdown.Item eventKey="7-2" componentClass={Link} to="/ipa/ia/simulacoes-analises">
                Previsão de demanda
              </Dropdown.Item>
            </Dropdown>
          </Whisper>
        </>
      )}
    </Nav>
  );
};

export const IsaMenu = ({ user }) => (
  <Nav className="sidebar-desktop" data-isa-menu>
    <Nav.Item
      eventKey="1"
      componentClass={Link}
      to="/isa/historico-preco"
      icon={
        <Icon asChild>
          <MdTimeline size={20} style={{ height: '20px', width: '20px' }} />
        </Icon>
      }
    >
      Histórico de preço
    </Nav.Item>
    {user?.servicoColeta?.relatoriosCustomizados ? (
      <Nav.Item
        eventKey="2"
        componentClass={Link}
        to="/isa/download-relatorio"
        icon={
          <Icon asChild>
            <MdFileDownload size={20} style={{ height: '20px', width: '20px' }} />
          </Icon>
        }
      >
        Download de relatório
      </Nav.Item>
    ) : null}
    <Nav.Item
      componentClass={Link}
      to="/isa/extracao-dados"
      eventKey="3"
      icon={
        <Icon asChild>
          <MdFileDownload size={20} style={{ height: '20px', width: '20px' }} />
        </Icon>
      }
    >
      Extração de dados
    </Nav.Item>
    <Nav.Item
      eventKey="4"
      componentClass={Link}
      to="/isa/gestao-retorno"
      icon={
        <Icon asChild>
          <MdLibraryAddCheck size={20} style={{ height: '20px', width: '20px' }} />
        </Icon>
      }
    >
      Gestão do Retorno
    </Nav.Item>
    <Nav.Item
      eventKey="5"
      componentClass={Link}
      to="/isa/acompanhamento-coletas"
      icon={
        <Icon asChild>
          <MdWatchLater size={20} style={{ height: '20px', width: '20px' }} />
        </Icon>
      }
    >
      Acompanhamento de Coletas
    </Nav.Item>
    <Nav.Item
      eventKey="6"
      componentClass={Link}
      to="/isa/revisao-lista"
      icon={
        <Icon asChild>
          <RevisaoListaIcon />
        </Icon>
      }
    >
      Revisão de Lista
    </Nav.Item>
    <Nav.Item
      eventKey="7"
      componentClass={Link}
      to="/isa/lojas-bloqueadas"
      icon={
        <Icon asChild>
          <LojasBloqueadasIcon />
        </Icon>
      }
    >
      Lojas Bloqueadas
    </Nav.Item>
  </Nav>
);

export const InfoPanelMenu = ({ user, activeKeyMenu }) => {
  const isFREE = user?.servicoPanel?.pacotePainel.name === 'FREE';

  const INDUSTRY_PERMISSION = ['ADERENCIA_COMPETITIVIDADE', 'ELASTICIDADE_CRUZADA'];
  const IS_INDUSTRY = INDUSTRY_PERMISSION.some(permission => user?.tipoAdicionalContratos?.PAN?.includes(permission));
  const hasMonitoramentoContratado = user?.tipoAdicionalContratos?.PAN?.includes('MONITORAMENTO_E_ALERTAS');

  return (
    <Nav className="sidebar-desktop" data-infopanel-menu>
      <Nav.Item
        eventKey="1"
        componentClass={Link}
        to={isFREE ? '/isa/painel-geral-free' : '/isa/painel-geral'}
        icon={
          <Icon asChild>
            <PanelIcon />
          </Icon>
        }
      >
        Panel
      </Nav.Item>
      <Nav.Item
        eventKey="3"
        componentClass={Link}
        to={isFREE ? '/isa/modulo-relatorio-free' : '/isa/modulo-relatorio'}
        icon={
          <Icon asChild>
            <MdAssignment size={20} style={{ height: '20px', width: '20px' }} />
          </Icon>
        }
      >
        Módulo de Relatório
      </Nav.Item>
      <Nav.Item
        eventKey="4"
        componentClass={Link}
        to={isFREE ? '/isa/analise-competitividade/varejo-free' : '/isa/analise-competitividade/varejo'}
        icon={
          <Icon asChild>
            <MdEmojiEvents size={20} style={{ height: '20px', width: '20px' }} />
          </Icon>
        }
      >
        Análise de Competitividade
      </Nav.Item>
      <Nav.Item
        eventKey="5"
        componentClass={Link}
        to={isFREE ? '/isa/lojas-concorrentes-free' : '/isa/lojas-concorrentes'}
        icon={
          <Icon asChild>
            <MdStore size={20} style={{ height: '20px', width: '20px' }} />
          </Icon>
        }
      >
        Lojas concorrentes
      </Nav.Item>
      <Nav.Item
        eventKey="7"
        componentClass={Link}
        to={isFREE ? '/isa/aderencia-precos-free' : '/isa/aderencia-precos'}
        icon={
          <Icon asChild>
            <AderenciaPrecosIcon />
          </Icon>
        }
      >
        Aderência de Preços
      </Nav.Item>
      {IS_INDUSTRY ? (
        <Whisper placement="topStart" speaker={<Tooltip>Inteligência para a Indústria</Tooltip>}>
          <Dropdown
            activeKey={activeKeyMenu}
            eventKey="8"
            title="Inteligência para a Indústria"
            placement="rightStart"
            icon={
              <Icon asChild>
                <img src={IndustriaIcon} alt="Inteligência para a Indústria" style={{ height: '20px', width: '20px' }} />
              </Icon>
            }
          >
            <Dropdown.Item eventKey="8-1" componentClass={Link} to={isFREE ? '/isa/visao-geral-elasticidade-free' : '/isa/visao-geral-elasticidade'}>
              Visão geral de elasticidade
            </Dropdown.Item>
            <Dropdown.Item eventKey="8-2" componentClass={Link} to={isFREE ? '/isa/elasticidade-cruzada-free' : '/isa/elasticidade-cruzada'}>
              Análise de elasticidade
            </Dropdown.Item>
          </Dropdown>
        </Whisper>
      ) : null}
      {user?.servicoPanel?.pacotePainel.name !== 'FREE' && (user?.usuarioAdministrador || user?.login?.includes('@infoprice.co')) ? (
        <Nav.Item
          eventKey="2"
          componentClass={Link}
          to={isFREE ? '/isa/solicitacao-ondemand-free' : '/isa/solicitacao-ondemand'}
          icon={
            <Icon asChild>
              <MdAdsClick size={20} style={{ height: '20px', width: '20px' }} />
            </Icon>
          }
        >
          On-Demand
        </Nav.Item>
      ) : null}

      <Nav.Item
        eventKey="6"
        componentClass={Link}
        to={isFREE ? '/isa/analise-cobertura-free' : '/isa/analise-cobertura'}
        icon={
          <Icon asChild>
            <AnaliseCoberturaIcon />
          </Icon>
        }
      >
        Análise de Cobertura
      </Nav.Item>
      <Nav.Item
        eventKey="9"
        componentClass={Link}
        to={isFREE ? '/isa/modulo-omnichannel-free' : '/isa/modulo-omnichannel'}
        icon={
          <Icon asChild>
            <MdHub style={{ height: '20px', width: '20px' }} />
          </Icon>
        }
        renderItem={() => (
          <Link to="/isa/modulo-omnichannel" className="rs-nav-item-content">
            <Icon asChild>
              <MdHub style={{ height: '20px', width: '20px' }} />
            </Icon>
            Módulo Omnichannel
          </Link>
        )}
      >
        Módulo Omnichannel
      </Nav.Item>
      {hasMonitoramentoContratado && (
        <Nav.Item
          eventKey="10"
          componentClass={Link}
          to="/isa/central-de-monitoramento"
          icon={
            <Icon asChild>
              <IoMdNotifications size={20} style={{ height: '20px', width: '20px' }} />
            </Icon>
          }
        >
          Central de Monitoramento
        </Nav.Item>
      )}
    </Nav>
  );
};

export const IraMenu = () => (
  <Nav className="sidebar-desktop" data-ira-menu>
    <Nav.Item componentClass={Link} to="/ira" eventKey="1" icon={<Icon icon="home" />}>
      Home
    </Nav.Item>
    <Nav.Item componentClass={Link} to="/ira/competitividade-geral" eventKey="2" icon={<Icon icon="trophy" />}>
      Competitividade geral
    </Nav.Item>
    <Nav.Item componentClass={Link} to="/ira/margem-praticada-geral" eventKey="3" icon={<Icon icon="usd" />}>
      Margem praticada geral
    </Nav.Item>
    <Nav.Item componentClass={Link} to="/ira/vendas-gerais" eventKey="4" icon={<Icon icon="charts-line" />}>
      Vendas gerais
    </Nav.Item>
  </Nav>
);

export const PaineisCustomizadosMenu = ({ paineis }) => (
  <Nav className="sidebar-desktop" data-paineis-customizados-menu>
    {paineis?.length
      ? paineis.map((item, index) => (
          <Nav.Item
            key={item?.codigo}
            eventKey={(index + 1).toString()}
            componentClass={Link}
            to={item?.nome ? `/analise/${item?.codigo}` : `/acompanhamento/${item?.codigo}`}
            icon={<Icon icon="user-analysis" />}
          >
            {item?.nome || item?.titulo}
          </Nav.Item>
        ))
      : null}
  </Nav>
);

export const CalculadoraPrevisaoDemandaMenu = () => (
  <Nav className="sidebar-desktop" data-calculadora-demanda-menu>
    <Nav.Item
      componentClass={Link}
      to="/ipa/calculadora-demanda"
      eventKey="1"
      icon={
        <Icon asChild>
          <MdCalculate size={20} style={{ height: '20px', width: '20px' }} />
        </Icon>
      }
    >
      Simulador de demanda
    </Nav.Item>
    <Nav.Item
      componentClass={Link}
      to="/ipa/cenarios-salvos"
      eventKey="2"
      icon={
        <Icon asChild>
          <MdSave size={20} style={{ height: '20px', width: '20px' }} />
        </Icon>
      }
    >
      Cenários salvos
    </Nav.Item>
  </Nav>
);

export const PlataformaPrecificacaoMenu = () => (
  <Nav className="sidebar-desktop" data-plataforma-precificacao-menu>
    <Nav.Item componentClass={Link} to="/ipa/gerenciar-tabela-comercial" eventKey="1" icon={<Icon icon="check-circle" />}>
      Gestão da tabela comercial
    </Nav.Item>
    <Nav.Item componentClass={Link} to="/ipa/plataforma-editar-tabela-base" eventKey="2" icon={<Icon icon="flag" />}>
      Tabela base
    </Nav.Item>
    <Nav.Item componentClass={Link} to="/ipa/lista-tabelas-preco" eventKey="3" icon={<Icon icon="usd" />}>
      Lista de tabelas de preço
    </Nav.Item>
  </Nav>
);
